import React from 'react';
// ANTD
import Steps from 'antd/lib/steps';
import Icon from 'antd/lib/icon';

const Step = Steps.Step;

const styles = {
  container: {
    minHeight: '100vh',
    backgroundColor: '#FBFCFC',
    flexDirection: 'column',
    display: 'flex',
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    padding: 40,
  },
  loadingContainer: {
    display: 'flex',
    width: '100%',
    height: '100%',
    alignItems: 'center',
    justifyContent: 'center',
  },
};

const ContractSteps = ({ current, windowWidth }) => {
  let bigWindow = windowWidth > 780; // only show a title if it's a big screen, otherwise remove it to save space on small screens
  return (
    <Steps current={current}>
      <Step title={bigWindow ? 'DRAFT' : null} icon={<Icon type="credit-card" />} />
      <Step title={bigWindow ? 'SIGN' : null} icon={<Icon type="solution" />} />
      <Step title={bigWindow ? 'SEND' : null} icon={<Icon type="mail" />} />
      <Step title={bigWindow ? 'ACCEPT' : null} icon={<Icon type="check-circle" />} />
    </Steps>
  );
};

export default ContractSteps;



// WEBPACK FOOTER //
// ./src/components/common/ContractSteps/index.js